module.exports = __webpack_public_path__ + "static/media/develop-03.eb4a8318.png";